import React from "react";
import { ClientApartment } from "../../../utils/api/apartmentRentalsAPI";
import { CalDate, fmtAmount, fmtDate } from "./bookingPricing";

interface Props {
  apt: ClientApartment;
  checkIn: CalDate | null;
  checkOut: CalDate | null;
  nights: number;
  totalGuests: number;
  amount: number;
  ctaLabel: string;
  ctaDisabled: boolean;
  submitting: boolean;
  onContinue: () => void;
  lang: string;
}

const BookingSummarySidebar: React.FC<Props> = ({
  apt, checkIn, checkOut, nights, totalGuests, amount, ctaLabel, ctaDisabled, submitting, onContinue, lang,
}) => (
  <aside className="pab-sidebar">
    <div className="pab-sidebar__card">
      <div className="pab-sidebar__apt">
        {apt.images?.[0] && <img src={apt.images[0]} alt={apt.name} className="pab-sidebar__thumb" />}
        <div>
          <div className="pab-sidebar__apt-name">{apt.name}</div>
          <div className="pab-sidebar__apt-loc">📍 {apt.location}</div>
        </div>
      </div>

      <div className="pab-sidebar__divider" />

      <div className="pab-sidebar__rows">
        <div className="pab-sidebar__row">
          <span>{lang === "en" ? "Dates" : "Datumi"}</span>
          <span>
            {checkIn && checkOut
              ? `${fmtDate(checkIn.year, checkIn.month, checkIn.day)} – ${fmtDate(checkOut.year, checkOut.month, checkOut.day)}`
              : (lang === "en" ? "Not selected" : "Nije odabrano")}
          </span>
        </div>
        {nights > 0 && (
          <div className="pab-sidebar__row">
            <span>{lang === "en" ? "Nights" : "Noćenja"}</span>
            <span>{nights}</span>
          </div>
        )}
        <div className="pab-sidebar__row">
          <span>{lang === "en" ? "Guests" : "Gosti"}</span>
          <span>{totalGuests}</span>
        </div>
      </div>

      <div className="pab-sidebar__divider" />

      <div className="pab-sidebar__total">
        <span>{lang === "en" ? "Total" : "Ukupno"}</span>
        <span>{amount > 0 ? fmtAmount(amount, apt.currency) : "—"}</span>
      </div>

      <button
        type="button"
        className="pab-cta-btn"
        disabled={ctaDisabled || submitting}
        onClick={onContinue}
      >
        {submitting ? (lang === "en" ? "Sending…" : "Slanje…") : ctaLabel}
      </button>
    </div>
  </aside>
);

export default BookingSummarySidebar;
